<template>
  <div class="nav-cnt">
    <b-navbar>
      <b-navbar-brand>
        <img
          class="logo"
          src="@/assets/images/icons/nav/Logo.svg"
          alt="Cardinal Logo"
        />
      </b-navbar-brand>
      <!-- <b-navbar-nav class="ml-auto">
        <p class="music-on" @click="music ? musicOff() : musicOn()">
          Music {{ music ? "On" : "Off" }}
        </p>
        <img
          class="music-on-img"
          src="@/assets/images/icons/nav/music.svg"
          alt="Music On/Off"
        />
      </b-navbar-nav> -->
    </b-navbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Nav",
  computed: {
    ...mapState(["global"]),
    music() {
      return this.$store.getters.getMusic;
    },
  },
  methods: {
    musicOn() {
      this.$store.dispatch("musicOn");
    },
    musicOff() {
      this.$store.dispatch("musicOff");
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-cnt {
  position: fixed;
  width: 100vw;
  z-index: 3;
  .navbar {
    height: 80px;
    background: #fff;
  }
  .logo {
    height: 50px;
    width: 54px;
    filter: drop-shadow(0 6px 30px 0 rgba(0, 0, 0, 0.2));
    margin-left: calc(48px - 1rem);
  }
  .music-on {
    font-size: 11px;
    line-height: 12px;
    letter-spacing: 2px;
    color: $grey;
    text-transform: uppercase;
    font-weight: 900;
    cursor: pointer;
    margin: 2px 0 0 0;
  }
  .music-on-img {
    margin: 0 26.5px 0 13.5px;
  }
}
</style>
